"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";
import { trimImageUrl } from "@/lib/profile-chrome-colors";
import {
  getProfileCoverHeight,
  PROFILE_COVER_HEIGHT_DESKTOP,
} from "@/lib/profile-scroll-effects";

export const PROFILE_COVER_HEIGHT = PROFILE_COVER_HEIGHT_DESKTOP;

type ProfileCoverBandProps = {
  bannerUrl?: string | null;
  placeholderGradientReady?: boolean;
  className?: string;
  scrollY?: number;
  collapseOnScroll?: boolean;
  baseHeight?: number;
};

export function ProfileCoverBand({
  bannerUrl,
  placeholderGradientReady = true,
  className,
  scrollY = 0,
  collapseOnScroll = false,
  baseHeight = PROFILE_COVER_HEIGHT_DESKTOP,
}: ProfileCoverBandProps) {
  const trimmedBanner = trimImageUrl(bannerUrl);
  const showBanner = trimmedBanner.length > 0;
  const showGradient = !showBanner && placeholderGradientReady;
  const height = collapseOnScroll ? getProfileCoverHeight(scrollY, baseHeight) : baseHeight;

  return (
    <div
      className={cn(
        "relative w-full overflow-hidden rounded-xl border border-border/60 transition-[height] duration-200 ease-out",
        // Solid white behind uploaded banners (both themes) so transparent
        // PNGs composite on white instead of the theme surface.
        showBanner ? "bg-white" : "bg-muted",
        className,
      )}
      style={{ height }}
    >
      {showGradient ? (
        <div
          className={cn(
            "absolute inset-0 profile-cover-theme-gradient dark:profile-cover-theme-gradient-dark",
          )}
        />
      ) : null}
      {showBanner ? (
        <Image
          src={trimmedBanner}
          alt=""
          fill
          className="object-cover"
          sizes="(max-width: 768px) 100vw, 640px"
          priority
        />
      ) : null}
      {!showBanner && !placeholderGradientReady ? (
        <div className="absolute inset-0 animate-pulse bg-muted" />
      ) : null}
    </div>
  );
}
